site.search = {
	tOut: null,

	init: function() {
		$('.gler', '#top').bind('click', function () {
			if ($('body').hasClass('open-search')) {
				site.search.closeSearch();
			} else {
				$('body').addClass('open-search');
				$('.searchDrop').find('#q').focus();
			}

		});

		// Add search to mobile menu
		var $searchForm = $('#searchForm');
		var $menu = $('ul.mmLevel1', '#mobilemenu');
		$menu.prepend($searchForm.clone().wrap("<li class='search'></div>").parent());
		$('#q', '#mobilemenu').attr('id', 'mobileQ');
		$('#elm_q > label', '#mobilemenu').attr('for', 'mobileQ');

		// Close search on esc press
		$(document).keydown(function(e) {
			if (e.keyCode == 27) {
				site.search.closeSearch();
			}
		});

		$('body').on('click', function (e) {
			if (!$(e.target).parents('.searchDrop').length && !$('.searchDrop').is(e.target) && !$(e.target).parents('.gler').length) {
				site.search.closeSearch();
			}
		});

		$('body').on('click', function (e) {
			if ($(e.target).parents('.glerClose').length) {
				e.preventDefault();
				site.search.closeSearch();
			}
		});
	},

	closeSearch: function() {
		$('body').removeClass('open-search');
	}
};

site.inits.push('site.search.init()');
